import { IconViewfinder } from "@tabler/icons";
import { get_lottie_obj } from "../common/utils";
import AnalyticsTabs from "./AnalyticsTabs";

const TestAnalyticsAccuracy = ({ description, number = 10, other = 25 }) => {
    const diff = (number - other).toFixed(1);
    return (
        <AnalyticsTabs
            title={"Accuracy"}
            // TitleIcon={IconViewfinder}
            AnimateIcon={get_lottie_obj({
                datakey: "target",
                width: 50,
                top: -10,
                left: "calc(100% - 35px)",
                position: "absolute",
            })}
            number={number}
            diff={diff}
            num_suffix="%"
            diffprefix=""
            diffsuffix="%"
            description="Compared with overall average accuracy of other aspirants"
        />
    );
};

export default TestAnalyticsAccuracy;
